import axiosInstance from 'api/axiosInstance';

const deleteUser = async (userId) => {
	const { data } = await axiosInstance.post('/api/userservice/DeleteUser', {
		userId,
	});
	return data;
};

export default deleteUser;
